import { action } from 'typesafe-actions'
import { CourseActionTypes } from './types'
import { ICourse } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(CourseActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: ICourse[]) => action(CourseActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(CourseActionTypes.LIST_ERROR, errors)
export const listClear = () => action(CourseActionTypes.LIST_CLEAR)

// Select Data
export const selectData = (id: string) => action(CourseActionTypes.SELECT, id)
export const selectedData = () => action(CourseActionTypes.SELECTED)
export const selectedClear = () => action(CourseActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: ICourse) => action(CourseActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: ICourse) => action(CourseActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(CourseActionTypes.CREATE_ERROR, errors)

// // Read
// export const readRequest = (data: Course) => action(CourseActionTypes.READ_REQUEST, data)
// export const readSuccess = (data: Course) => action(CourseActionTypes.READ_SUCCESS, data)
// export const readError = (message: string) => action(CourseActionTypes.READ_ERROR, message)

// Update
export const updateRequest = (keyValues: any) => action(CourseActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: ICourse) => action(CourseActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(CourseActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: ICourse) => action(CourseActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(CourseActionTypes.DELETE_SUCCESS, id)  // Return deleted course id to remove from state
export const deleteError = (errors: any) => action(CourseActionTypes.DELETE_ERROR, errors)
